"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FolderDetail = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const TreeStructure_1 = __importDefault(require("../../components/Other/TreeStructure"));
const FolderWrapper = styled_components_1.default.div `
  width: 100%;
  height: 100%;
  background: #fff;
`;
const FolderDetail = ({ folderContent }) => (react_1.default.createElement(FolderWrapper, null,
    react_1.default.createElement(TreeStructure_1.default, { collection: folderContent.children })));
exports.FolderDetail = FolderDetail;
exports.default = exports.FolderDetail;
